import { Nanium } from 'nanium/core';
import { LogLevel } from 'nanium/interfaces/logger';
import { NaniumConsumerBrowserHttp } from 'nanium/managers/consumers/browserHttp';
import { ClientRequestInterceptor } from './request-interceptor';
import { isOneOf } from '../../../shared/o';
import { ErrorCode, ServiceError } from '../../../server/services/errors';
import { initialize } from '@ionic/core';
import { Session } from './session';
import { Router } from './router';
import { AppConfig } from './config';
import { NaniumProviderBrowser } from 'nanium/managers/providers/browser';

export default async () => {
  let serverBaseUrl: string = '';
  if (location.port === '3333') {
    serverBaseUrl = 'http://' + location.host.replace(/:\d{4}/gi, ':3000');
    Nanium.logger.loglevel = LogLevel.info;
  }

  await Nanium.addManager(new NaniumConsumerBrowserHttp({
    apiUrl: serverBaseUrl + '/services',
    apiEventUrl: serverBaseUrl + '/events',
    requestInterceptors: [ClientRequestInterceptor],
    handleError: (e) => handleError(e),
  }));

  await Nanium.addManager(new NaniumProviderBrowser({
    isResponsible: (_request: any, serviceName: string) => Promise.resolve(serviceName.startsWith('EduApplicationClient:') ? 2 : 0),
    isResponsibleForEvent: (eventName) => Promise.resolve(eventName.startsWith('EduApplicationClient:') ? 2 : 0),
    handleError: (e) => handleError(e),
  }));

  await AppConfig.load();

  initialize(); // Initialize Ionic components globally
};

async function handleError(err: ServiceError): Promise<void> {
  if (typeof err === 'string') {
    if (isOneOf(err, ErrorCode.unauthenticated, ErrorCode.unauthorized)) {
      if (Router.url.pathname === '/login') {
        throw err;
      } else {
        Session.abandon();
        Router.push('/login/')
        return;
      }
    }
  } else if (err.id) {
    alert('An unexpected error occurred: ' + err.id);
  }
  throw err;
}
